

























import Vue from "vue";
import Tabs from "@/components/ui/Tabs.vue";
import StammdatenTab from "@/components/tabs/kommunen/StammdatenTab.vue";
import DocumentsTab from "@/components/tabs/kommunen/DocumentsTab.vue";
import ConceptsTab from "@/components/tabs/kommunen/ConceptsTab.vue";
import UmsetzungsTab from "@/components/tabs/kommunen/UmsetzungsTab.vue";
import { MetaInfo } from "vue-meta";
import { Kommune } from "@/types/Kommune";

export default Vue.extend({
  name: "KommuneDetail",
  components: {
    Tabs,
    StammdatenTab,
    ConceptsTab,
    DocumentsTab,
    UmsetzungsTab,
  },
  metaInfo(): MetaInfo {
    return {
      title: this.name,
    };
  },
  props: {
    /** passed via router through uri parameter */
    id: {
      type: [String, Number],
      required: true,
    },
  },
  data: function () {
    return {
      stammdaten: {} as Kommune,
    };
  },
  computed: {
    name(): string {
      return this.stammdaten?.name || "Kommune";
    },
  },
});
